import React from 'react'
import { capitalLetter } from '../../../../utils/utils'

const TablaRepuestos = ({
	idTablaRepuestos,
	repuestoTipo,
	repuestos,
	setRepuesto,
	repuestoDefault,
	openModalRepuesto,
	setTextoAnulacion,
	openModalEliminar,

}) => {
	const BotonEditar = ({
		setRepuesto,
		repuestoDefault,
		data,
		openModalRepuesto
	}) => {
		return (
			<button 
				onClick={() => {
					setRepuesto(Object.assign({},repuestoDefault,data))    //PARA QUE CONSERVE LAS PROPIEDADES QUE NO TRAE EL ENDPOINT
					openModalRepuesto()
				}} 
				className="bg-blue-500 hover:bg-blue-600 rounded w-[25px] h-[25px] text-xs"
			>
				<i className="fas fa-edit"></i>
			</button>
		)
	}

	const BotonEliminar = ({
		setRepuesto,
		repuestoDefault,
		data,
		setTextoAnulacion,
		openModalEliminar,
	}) => {
		return (
			<button
				onClick={() => {
					setRepuesto(Object.assign({},repuestoDefault,data))    //PARA QUE CONSERVE LAS PROPIEDADES QUE NO TRAE EL ENDPOINT
					setTextoAnulacion('')
					openModalEliminar()
				}}
				className="bg-red-500 hover:bg-red-800 rounded w-[25px] h-[25px] text-xs"
			>
				<i className="fas fa-trash"></i>
			</button>
		) 
	}
	
	return (
		<div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
			<table id={idTablaRepuestos} className="tableResponsive">
				<thead>
					<tr>
						<th className="text-left w-[20px]">N°</th>
						<th className="text-left ">NOMBRE</th>
						{repuestoTipo == 0 ? <th className='text-left'>TIPO</th> : <></>}
						<th className="text-left w-[200px]">MARCA</th>
						<th className="text-left w-[150px]">CÓDIGO</th>
						<th className="text-left w-[150px]">U.MED</th>
						<th className="w-[35%]">CARACTERISTICAS</th>
						<th className=""></th>
						<th className="">CATEGORIA</th>
						<th className="w-[150px]"></th>
					</tr>
				</thead>
				<tbody>
				{   
						repuestos.length > 0 
						? repuestos.map((data, i) => {
							return (
								<tr key={i+1} className=''>
									<td data-label="" className='text-center w-[20px]'> {++i}</td>
									<td data-label="Nombre" className=""><div className='max-w-[300px] text-ellipsis whitespace-nowrap overflow-hidden'>{data.nombreRepuesto}</div></td>
									{repuestoTipo == 0 ? <td data-label="Tipo">{data.nomRepuestoTipo}</td> : <></>}
									<td data-label="Marca" className="w-[120px]">{data.marca || '-'}</td>
									<td data-label="Codigo" className="w-[200px]">{data.codigoInterno}</td>
									<td data-label="U. Medida" className="w-[150px]">{data.nomRepuestoUM}</td>
									<td data-label="Caracteristicas" title={data.caracteristicas || '-'} className="w-[35%]">
										<div className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">{data.caracteristicas || '-'}</div>
									</td>
									<td data-label="A.Neumático" className='text-center'>
										{
											data.afectaNeumatico 
											? 	<>
													<i title='Afecta neumático' className="fa fa-bus lg:hidden" aria-hidden="true"></i>
													<span className='hidden lg:block'>Sí</span>
												</> 
											: 	<>
													<span className='lg:hidden'>-</span>
													<span className='hidden lg:block'>No</span>
												</>
										}
									</td>
									<td data-label="Categoria" className="!flex justify-between">
										<div className ='cursor-pointer whitespace-nowrap bg-green-600 px-2 py-[2px] h-fit text-center w-[150px] rounded text-[12px] font-bold '>{capitalLetter(data.categoria)}</div>
									</td>
									<td data-label="Opciones" className="tableopciones text-center w-fit whitespace-nowrap" >
										<div className='flex gap-2 flex-grow justify-end items-center' >
											<BotonEditar
												setRepuesto = {setRepuesto}
												repuestoDefault = {repuestoDefault}
												data = {data}
												openModalRepuesto = {openModalRepuesto}
											></BotonEditar>
											<BotonEliminar
												setRepuesto = {setRepuesto}
												repuestoDefault = {repuestoDefault}
												data = {data}
												setTextoAnulacion = {setTextoAnulacion}
												openModalEliminar = {openModalEliminar}
											></BotonEliminar>
										</div>
									</td>
								</tr>
							)
						})
						: <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
					}
				</tbody> 
			</table>
		</div>
	)
}

export default TablaRepuestos